import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useThemeContext } from "../../../Context/ThemeContext";
import AbsenBulananColumns from "../constants/TableColumnsAbsenBulanan";
import MonthFilterComponent from "./filter/MonthFilterComponent";
import { SearchBar } from "../../../CommonElements";
import { useStaf } from "../../../Context/StafContext";

const AbsenListBulanan = ({
  data,
  monthFilter,
  updateMonthFilter,
  pending,
}) => {
  const stafAPI = useStaf();
  const { themeContext } = useThemeContext();

  const [stafList, setStafList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [filterStaf, setFilterStaf] = useState("");
  const [options, setOptions] = useState({
    Grup: [],
  });
  const [selectedItems, setSelectedItems] = useState({
    Grup: [],
  });

  useEffect(() => {
    refreshGroupStaf();
  }, []);

  const refreshGroupStaf = () => {
    stafAPI.getGroupStaf().then((res) => {
      const mappedStatus = res.data.map((item) => ({
        id: item.id_group,
        name: item.nama,
      }));

      setOptions((prev) => ({
        ...prev,
        Grup: mappedStatus,
      }));
    });
  };

  useEffect(() => {
    let newData = data || [];

    newData = newData.filter((item) =>
      item.nama?.toLowerCase().includes(filterStaf.toLowerCase())
    );

    if (selectedItems.Grup.length > 0) {
      const selectedGroupNames = selectedItems.Grup.map(
        (id) => options.Grup.find((group) => group.id === id)?.name
      );

      newData = newData.filter((item) =>
        selectedGroupNames.includes(item.group_staf)
      );
    }

    newData = newData.map((item) => ({ ...item, month: monthFilter }));

    setStafList(newData);
  }, [data, filterStaf, selectedItems.Grup]);

  useEffect(() => {
    let monthList = [];

    for (
      let date = new Date(monthFilter + "-01");
      date.getMonth() !== (new Date(monthFilter + "-01").getMonth() + 1) % 12;
      date.setDate(date.getDate() + 1)
    ) {
      monthList.push({
        tanggal: new Date(date),
      });
    }

    setDateList(monthList);
  }, [monthFilter]);

  const subHeaderComponent = (
    <div className="d-flex w-100 flex-column gap-3">
      <SearchBar className={"align-items-end ms-auto"} onChange={(e) => setFilterStaf(e.target.value)} />
      <MonthFilterComponent
        updateMonthFilter={updateMonthFilter}
        filter={true}
        options={options}
        setState={setSelectedItems}
        state={selectedItems}
      />
    </div>
  );

  return (
    <DataTable
      data={stafList}
      columns={AbsenBulananColumns(dateList)}
      pagination
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign="right"
      // persistTableHead
      // customStyles={customStyles}
      progressPending={pending}
      theme={themeContext}
    />
  );
};

export default AbsenListBulanan;
